/**
 * LGFramingSequence.tsx - Sequence definition for the Loss-Gain framing experiment
 * Last updated: 2025-08-13 07:36:25
 * Updated by: JulianPolly
 */

import { ScreenSequence } from "../Sequences";
import { LGScreen1 } from "./LGScreen1";
import { LGScreen2 } from "./LGScreen2";
import { ResultScreen } from "./ResultScreen";
import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { ExplainationScreen } from "./ExplanaitionScreen";
import { useSession } from "../../../SessionContext";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { useLanguage } from "../../../../context/LanguageContext";

export const LGFramingKey = "LGFraming";

// Factory-Funktion, die die passende Sequence für die aktuelle userData erzeugt
export function useLGFramingSequence(): ScreenSequence {
    const { userData } = useSession();
    const { t } = useLanguage();

    // Default auf Bedingung 1, falls nichts gefunden wird:
    const randomizer1 = userData?.randomizer1 || "Bedingung 1";

    return {
        name: t('experiments', 'LGFraming', 'title'),
        description: t('experiments', 'LGFraming', 'description'),
        group: "A1",
        screens: [
            randomizer1 === "Bedingung 2"
                ? { component: LGScreen2 }
                : { component: LGScreen1 },
            { component: ResultScreen.component },
            { component: ResultScreenGlobal.component },
            { component: ExplainationScreen.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,  // Nur hier!
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 3
    };
}